// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-create-workbook-entry__content {
  padding: 30px 0;
}
.dl-dialog-create-workbook-entry__row {
  display: flex;
}
.dl-dialog-create-workbook-entry__row-label {
  line-height: 28px;
  margin-right: 12px;
}
.dl-dialog-create-workbook-entry__warning {
  margin-top: 30px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogCreateWorkbookEntry/DialogCreateWorkbookEntry.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR;AAGI;EACI,aAAA;AADR;AAII;EACI,iBAAA;EACA,kBAAA;AAFR;AAKI;EACI,gBAAA;AAHR","sourcesContent":[".dl-dialog-create-workbook-entry__content {\n  padding: 30px 0;\n}\n.dl-dialog-create-workbook-entry__row {\n  display: flex;\n}\n.dl-dialog-create-workbook-entry__row-label {\n  line-height: 28px;\n  margin-right: 12px;\n}\n.dl-dialog-create-workbook-entry__warning {\n  margin-top: 30px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
